
export default {
  getVessels: state => {
    return state.list ? state.list.toArray() : null;
  },
  getMax: state => {
    return state.max;
  },
  getOffset: state => {
    return state.offset;
  }
}
